import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { CadastroGrupo } from '../interfaces/cadastro-grupo';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class CadastroGrupoService {
  getProdutoGrupoPageSearch(arg0: number, arg1: number, value: string) {
    throw new Error('Method not implemented.');
  }
  getProdutoGrupoPage(arg0: number, arg1: number) {
    throw new Error('Method not implemented.');
  }

  readonly path = '/cadastro/grupo';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) {}

  saveOrUpdate(cadastro: CadastroGrupo): Observable<CadastroGrupo> {
    return this.http.put<CadastroGrupo>(`${this.jwtAuthService.apiUrl + this.path}`, cadastro);
  }

  getGrupo(id: number ): Observable<CadastroGrupo> {
    return this.http.get<CadastroGrupo>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  getGrupoPage(page?: number, size?: number,
    order?: string, direction?: string): Observable<PageResult<CadastroGrupo>> {
    return this.http.get<PageResult<CadastroGrupo>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/v2?page=${page}&size=`
     + `${size}&order=${order}&direction=${direction}`);
  }

  getGrupoPageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string): Observable<PageResult<CadastroGrupo>> {
    return this.http.get<PageResult<CadastroGrupo>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/v2?page=${page}&size=` +
    `${size}&search=${search}&order=${order}&direction=${direction}`);
  }
}
